import { render, staticRenderFns } from "./VeJwZhiyeExcelBanjiModal.vue?vue&type=template&id=2452d398"
import script from "./VeJwZhiyeExcelBanjiModal.vue?vue&type=script&lang=js"
export * from "./VeJwZhiyeExcelBanjiModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports